import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  <path fill="currentColor" d="M5 21q-.825 0-1.4125-.5875T3 19V5q0-.825.5875-1.4125T5 3h7v2H5v14h14v-7h2v7q0 .825-.5875 1.4125T19 21zm4.7-5.3-1.4-1.4L17.6 5H14V3h7v7h-2V6.4z" />
, 'DisplayExportx');
